module.exports = __webpack_public_path__ + "assets/img/star_sentence_un_select6.389e7969.png";